import { HttpEventType } from '@angular/common/http';
import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import readXlsxFile from 'read-excel-file';
import { filter, firstValueFrom, Subscription } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { UserModel } from 'src/app/models/authentication/user.model';
import { BalanceImportModel } from 'src/app/models/imports/balace-import.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { WindowService } from 'src/app/services/authentication/window.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { CompanyService } from 'src/app/services/management/company.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { ReverseRentalBalanceComponent } from '../reverse-rental-balance/reverse-rental-balance.component';
import { RentalBalanceService } from './../../../../services/rental/rental-balance.service';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-import-rental-balance',
  templateUrl: './import-rental-balance.component.html',
  styleUrls: ['./import-rental-balance.component.scss'],
  standalone: false
})

export class ImportRentalBalanceComponent implements OnInit {
  @ViewChild('reverseRentalBalanceModal') reverseRentalBalanceModalComponent?: CustomModalComponent | null = null;

  branchCode: number | null = null;
  branchId = 0;
  companyCode: number | null = null;
  companyId: number | null = null;
  eventFile: any;
  errorRentalBalance: number = 0;
  filters: ColumnResponseModel[] = [];
  formImport: FormGroup = new FormGroup({});
  listBranches: any[] = [];
  listCompanies: any[] = [];
  loadPreInvoicingModel: LoadPreInvoicingModel = new LoadPreInvoicingModel();
  nameWindow: string = 'Importación Saldos Alquiler';
  nameFile: string = 'Ningún archivo seleccionado.';
  isOpened: string | undefined = undefined;
  permissionUpdatable: boolean = false;
  projectName = ProjectName.projectName;
  componentRegisterReverseRentalBalance = ReverseRentalBalanceComponent;
  rentalBalanceAlerts: Array<PreInvoicingAlertModel> = new Array<PreInvoicingAlertModel>;
  subscription: Subscription;
  url: string = "balances-import";
  userAuthenticated: UserModel = new UserModel();
  visibleTxt: boolean = false;

  constructor(private branchService: BranchService,
    private companyService: CompanyService,
    private formBuilder: FormBuilder,
    private headerService: HeaderService,
    private rentalBalanceService: RentalBalanceService,
    private router: Router,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private userAuthenticatedService: UserAuthenticatedService,
    private windowService: WindowService) {
    this.getAllLists();
  }

  ngOnInit() {
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    const filters = localStorage.getItem(this.url);
    if (filters) this.filters = JSON.parse(filters);
    this.headerService.setTitle(this.nameWindow);
    this.getPermission();
    this.validateForm();
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  async ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }

    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  attach() {
    document.getElementById('fileImport')?.click();
  }

  clearInputFile() {
    this.nameFile = 'Ningún archivo seleccionado.';
    if (this.eventFile) {
      this.eventFile.target.value = '';
    }
  }

  downloadGuideImport() {
    this.rentalBalanceService.downloadGuideImport().subscribe(data => {
      switch (data.type) {
        case HttpEventType.Response: {
          const downloadedFile = new Blob([data.body!], { type: data.body!.type });
          const a = document.createElement('a');
          a.setAttribute('style', 'display:none;');
          document.body.appendChild(a);
          a.download = "GuiaSaldosAlquiler.docx";
          a.href = URL.createObjectURL(downloadedFile);
          a.target = '_blank';
          a.click();
          document.body.removeChild(a);
          break;
        }
      }
    });
  }

  downloadErrorsTxt() {
    if (!this.rentalBalanceAlerts || this.rentalBalanceAlerts.length === 0) {
      this.toastHandlerService.showToast('error', 'No hay alertas para exportar');
      return;
    }

    this.rentalBalanceService.exportImportErrors(this.rentalBalanceAlerts).subscribe({
      next: (blob: Blob) => {
        const file = new Blob([blob], { type: 'text/plain' });
        const url = window.URL.createObjectURL(file);
        const today = new Date();
        const formatDate = today.toISOString().split('T')[0];

        const a = document.createElement('a');
        a.href = url;
        a.download = `ErroresImportacionSaldosAlquiler_${formatDate}.txt`;
        a.click();

        window.URL.revokeObjectURL(url);
      },
      error: () => {
        this.toastHandlerService.showToast('error', 'Error al exportar el archivo');
      }
    });
  }

  importBalance() {
    this.rentalBalanceAlerts = [];
    this.errorRentalBalance = 0;
    this.visibleTxt = false;
    Object.keys(this.formImport.controls).forEach(key => {
      const control = this.formImport.get(key);
      if (control && control.invalid) {
        console.warn(`${key} es inválido`, control.errors, 'value:', control.value);
      }
    });
    if (this.formImport.valid) {
      let isOk: boolean = true;
      const input = document.getElementById("fileImport") as any;
      const rowsImports = new Array<BalanceImportModel>();
      let row: BalanceImportModel;
      let counter: number = 1, dateBalances: Date, costCenterCode: number, articleCode: number,
        storeCode: number, quantity: number, unitValue: number;
      if (input.files[0]) {
        readXlsxFile(input.files[0]).then(async (rows) => {
          if (rows.length <= 1) {
            this.toastHandlerService.showToast('warning', `El archivo ingresado no tiene registros para importar.`);
            return;
          }
          rows.splice(0, 1);

          rows.forEach(element => {
            counter = counter + 1;
            let rowHasError = false;

            dateBalances = this.formImport.get("dateBalances")?.value;
            //A. Código Compañía:
            const companyCode = parseFloat(element[0] as string);
            if (isNaN(companyCode)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}. El código de la Compañía no es válido. `;
              this.rentalBalanceAlerts.push(alert);
              rowHasError = true;
            } else {
              if (companyCode != this.companyCode) {
                const alert = new PreInvoicingAlertModel();
                alert.alertType = 1;
                alert.message = `Fila ${counter}. La Compañía del archivo no es igual a la Compañía seleccionada.`;
                this.rentalBalanceAlerts.push(alert);
                rowHasError = true;
              }
            }

            //B. Código Sucursales:
            const branchCode = parseFloat(element[1] as string);
            if (isNaN(branchCode)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}. El código de la Sucursal no es válido. `;
              this.rentalBalanceAlerts.push(alert);
              rowHasError = true;
            } else {
              if (branchCode != this.branchCode) {
                const alert = new PreInvoicingAlertModel();
                alert.alertType = 1;
                alert.message = `Fila ${counter}. La Sucursal del archivo no es igual a la Sucursal seleccionada.`;
                this.rentalBalanceAlerts.push(alert);
                rowHasError = true;
              }
            }

            //C. Código C.Costos:
            costCenterCode = parseFloat(element[2] as string);
            if (isNaN(costCenterCode)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}. El código del Centro de Costos no es válido.`;
              this.rentalBalanceAlerts.push(alert);
              rowHasError = true;
            }

            //D. Código Artículo:
            articleCode = parseFloat(element[3] as string);
            if (isNaN(articleCode)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}. El código del Articulo no es válido.`;
              this.rentalBalanceAlerts.push(alert);
              rowHasError = true;
            }

            //E. Código Bodega:
            storeCode = parseFloat(element[4] as string);
            if (isNaN(storeCode)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}. El código de la Bodega no es válido.`;
              this.rentalBalanceAlerts.push(alert);
              rowHasError = true;
            }

            //F. Cantidad:
            quantity = parseFloat(element[5] as string);
            if (isNaN(quantity)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}. La cantidad no es válida.`;
              this.rentalBalanceAlerts.push(alert);
              rowHasError = true;
            }

            //G. Valor Unitario:
            unitValue = parseFloat(element[6] as string);
            if (isNaN(unitValue)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}. El valor unitario no es válido.`;
              this.rentalBalanceAlerts.push(alert);
              rowHasError = true;
            }

            if (!rowHasError) {
              row = new BalanceImportModel(counter, this.branchId, dateBalances, costCenterCode, articleCode, storeCode, quantity, unitValue);
              rowsImports.push(row);
            } else {
              isOk = false;
            }
          });
          if (isOk && rowsImports.length > 0) {
            try {
              const response = await firstValueFrom(this.rentalBalanceService.importBalance(rowsImports));
              this.loadPreInvoicingModel = response;
              this.rentalBalanceAlerts = response?.alerts ?? [];
              this.errorRentalBalance = response?.preInvoicingStateId;
              if (this.errorRentalBalance === 1) {
                this.visibleTxt = true;
                this.toastHandlerService.showToast(
                  'error',
                  'La importación terminó con errores, puede exportarlos si lo desea.',
                  'ERROR');
              } else if (this.rentalBalanceAlerts.length > 0) {
                this.visibleTxt = true;
                this.toastHandlerService.showToast('error', 'La importación terminó con alertas, puede exportarlas si lo desea');
              } else {
                this.visibleTxt = false;
                this.toastHandlerService.showToast('success', `La importación terminó exitosamente.`);
              }
              this.clearInputFile();
            } catch (error) {
              this.nameFile = 'Ningún archivo seleccionado.';
              console.error('Error al importar Saldos Alquiler', error);
            }
          } else {
            this.errorRentalBalance = 1;
            this.visibleTxt = true;
            this.toastHandlerService.showToast(
              'error',
              'La importación terminó con errores, puede exportarlos si lo desea'
            );
          }
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No ha seleccionado ningún archivo.'
        });
      }
    } else {
      this.showValidationMessages();
    }
  }

  async getAllLists() {
    try {
      const [companies] = await Promise.all([
        firstValueFrom(this.companyService.getAllCompaniesForSelectAsync()),

      ]);
      this.listCompanies = companies;
      return true;
    } catch (error) {
      console.error('Error al obtener las listas.', error);
      return false;
    }
  }

  async getBranch(branchId: number) {
    if (branchId != null) {
      this.branchId = branchId;
      const branch = this.listBranches.find(x => x.value == branchId);
      this.branchCode = branch.code;
    } else {
      this.branchCode = null;
      this.branchId = 0;
    }
  }

  async getCompany(companyId: number | null) {
    if (companyId != null && companyId != 0) {
      this.companyId = companyId;
      const company = this.listCompanies.find(x => x.value == companyId);
      this.companyCode = company.code;
      this.listBranches = await firstValueFrom(this.branchService.GetAllBranchesByCompanyIdForSelectAsync(this.companyId));
    } else {
      this.companyId = null;
      this.companyCode = null;
      this.listBranches = [];
    }
  }

  getNameFile(file: any) {
    this.eventFile = file;
    const files = this.eventFile.target.files;
    if (files.length != 0) {
      for (let i = 0; i < files.length; i++) {
        this.nameFile = files[i].name;
      }
    } else {
      this.nameFile = 'Ningún archivo seleccionado.';
    }
  }

  async getPermission() {
    let url = this.router.url as string
    url = url.substring(1);
    this.url = url;
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast(
          'error',
          `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`
        );
      }
    } else {
      localStorage.clear();
    }
    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
    } catch (error) {
      console.error('Error al buscar los permisos por tipo de impuesto.', error);
    }
    this.getPermissionsForUserByWindow();
  }

  async getPermissionsForUserByWindow() {
    this.userAuthenticated = await firstValueFrom(
      this.userAuthenticatedService.userObservable.pipe(
        filter(user => user && user.userId !== 0)
      )
    );
  }

  reverseRentalBalance() {
    this.reverseRentalBalanceModalComponent && this.reverseRentalBalanceModalComponent.show();
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      companyId: {
        required: 'La compañía es obligatoria.',
        min: 'La compañía es obligatiria.',
      },
      branchId: {
        required: 'La sucursal es obligatoria.',
        min: 'La sucursal es obligatiria.'
      },
      dateBalances: {
        required: 'La fecha es obligatoria.'
      }
    };

    Object.keys(controlMessages).forEach(controlName => {
      const control = this.formImport.get(controlName);
      if (control && control.invalid && control.errors) {
        const errors = control.errors;
        Object.keys(errors).forEach(errorKey => {
          const message = controlMessages[controlName][errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message, 'Atención');
          }
        });
      }
    });
  }


  validateForm() {
    this.formImport = this.formBuilder.group({
      companyId: [0, [Validators.required, Validators.min(1)]],
      branchId: [0, [Validators.required, Validators.min(1)]],
      dateBalances: [null, [Validators.required]]
    });
  }

}
